<template>
  <div>
    <el-row class="title-bar">
      <span class="mr-r15 c-pointer" @click="onBackButtonClick"><i class="fas fa-long-arrow-left"></i></span>
      <div class="title-h4">인터페이스 추가</div>
    </el-row>
    <el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <w-physical-obj-table :active="active" selected-managetype-id="NMS" :checked-obj-list="checkedObjList" :show-netdevice-selection="false"/>
        </el-col>
        <el-col :span="12">
          <w-selected-obj-table :checked-obj-list="checkedObjList" :custom-table-columns="selectedObjTableColumns"/>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import trafficAPI from '@/api/settings/netdevice/traffic-settings';
import { convertValueForInterfaceSpeed } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import WPhysicalObjTable from '@/components/table/PhysicalObjTable/index';
import WSelectedObjTable from '@/components/table/SelectedObjTable';

export default {
  name: 'WAddInterfaceSettingView',
  components: {
    WPhysicalObjTable,
    WSelectedObjTable,
  },
  props: {
    viewParams: Object,
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHeaderSearchTool: false,
      columnDefault,
      selectedObjTableColumns: [
        { type: 'selection' },
        {
          prop: 'deviceName',
          label: '장비 명',
          searchable: true,
        },
        {
          prop: 'objName',
          label: '인터페이스 명',
          searchable: true,
        },
        {
          prop: 'netinterfaceName',
          label: '물리 인터페이스 명',
          searchable: true,
        },
      ],
      allInterfaces: [],
      addedInterfaces: [],
      notAddedInterfaces: [],
      checkedObjList: [],
    };
  },
  watch: {
    viewParams: {
      handler(value) {
        if (value.currentView === 'addInterfaceView') {
          // 현재 화면일때
          this.loadData();
          if (value.interfaceList) {
            this.addedInterfaces = value.interfaceList;
          }
        }
      },
      deep: true,
    },
    'viewParams.interfaceList': {
      handler(value) {
        this.checkedObjList = cloneDeep(value);
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 인터페이스 추가에 필요한 정보 가공
     * @author jeee12
     */
    getAddInterfaceInfo() {
      return { addedInterfaces: this.checkedObjList };
    },
    /**
     * 인터페이스 관리대상 전체 목록 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      trafficAPI.getInterfaceList({}).then((response) => {
        if (response.data.success) {
          this.allInterfaces = response.data.data;
          this.filterNotAddedDatas();
        }
      });
    },
    /**
     * 추가 목록에 따라 전체 인터페이스 목록 필터링
     * @author jeee12
     * @return {[type]} [description]
     */
    filterNotAddedDatas() {
      const strInterfaceIds = this.addedInterfaces.map((e) => e.netinterfaceId);
      this.notAddedInterfaces = this.allInterfaces.filter((e) => strInterfaceIds.indexOf(e.netinterfaceId) === -1);
    },
    /**
     * 뒤로가기 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onBackButtonClick() {
      this.$emit('change-view', 'basicInfoView');
      this.initData();
    },
    /**
     * 테이블 데이터 단위 변환
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertUnitValue(row, column, value) {
      return convertValueForInterfaceSpeed(value);
    },
    /**
     * 현재 화면 데이터 초기화
     * @author jeee12
     * @return {[type]} [description]
     */
    initData() {
      this.addedInterfaces = [];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/InterfaceGroupSettings/components/AddInterfaceSettingView.vue